import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useRestoreDisapprovalReason(shop: ShopDto) {
	return useApiMutation(
		"patch",
		"/shops/{shopId}/disapproval-reasons/{reasonId}/restore",
		{
			invalidate: useInvalidateShop(shop.id),
			mapVariables: (reasonId: string) => ({
				params: { path: { shopId: shop.id, reasonId } },
			}),
		},
	);
}
